<template>
  <div>
    <membership-form-dialog
      ref="membershipFormDialog"
      :enrollment-id="enrollmentId"
      :data="dialog.membership.data"
      :is-dialog-visible.sync="dialog.membership.isVisible"
      :membership-dates="childMemberships"
      @update="syncMembershipTableData"
    />

    <holding-form-dialog
      ref="holdingFormDialog"
      :data="dialog.holding.data"
      :child-membership-id="holdingChildMembershipId"
      :is-dialog-visible.sync="dialog.holding.isVisible"
      :memberships="childMemberships"
      @update="syncMembershipTableData"
    />

    <el-table
      v-loading="loading"
      :data="membershipTableData"
      class="fifl-main-table"
      header-row-class-name="fifl-table-header-row"
      header-cell-class-name="fifl-table-header-cell"
      :row-class-name="tableHoldingRowClass"
      cell-class-name="fifl-main-table-cell"
      :span-method="tableSpanRule"
    >
      <el-table-column
        label="회원권"
        prop="parent_membership"
        fixed="left"
        show-overflow-tooltip
        :min-width="columnWidth.membership+'px'"
      >
        <template slot-scope="scope">
          <template
            v-if="scope.row.type === 'membership'"
          >
            {{ scope.row.parent_membership.name }}
          </template>

          <template v-else>
            홀딩
          </template>
        </template>
      </el-table-column>

      <el-table-column
        label="시작일"
        prop="start"
        :min-width="columnWidth.start+'px'"
      >
        <template slot-scope="scope">
          {{ `${format(scope.row.start, 'YY.MM.DD')} - ${format(scope.row.end, 'YY.MM.DD')}` }}
        </template>
      </el-table-column>

      <el-table-column
        label="종료일"
        prop="duration"
        :min-width="columnWidth.end+'px'"
      />

      <el-table-column
        label="수업"
        prop="courseNames"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <template v-if="scope.row.type === 'membership'">
            <span slot="reference">
              {{ scope.row.courses.join(', ') }}
            </span>
          </template>

          <template v-else>
            {{ scope.row.memo }}
          </template>
        </template>
      </el-table-column>

      <el-table-column
        :label="'최대 수강 ' + membershipSystem.middle"
        prop="balance"
        :min-width="columnWidth.balance+'px'"
      >
        <template slot-scope="scope">
          {{ scope.row.balance === -1 ? "제한 없음" : scope.row.balance ? 
            numberWithCommas(scope.row.balance) : 
            scope.row.balance === 0 ? 0 : '' }}
        </template>
      </el-table-column>

      <el-table-column
        :label="'수강 ' + membershipSystem.middle"
        prop="consumed"
        :min-width="columnWidth.consumed+'px'"
      >
        <template slot-scope="scope">
          {{ scope.row.consumed + scope.row.wait_consumed ?
            numberWithCommas(scope.row.consumed + scope.row.wait_consumed) :
            scope.row.consumed + scope.row.wait_consumed === 0 ? 0 : '' }}
        </template>
      </el-table-column>

      <el-table-column
        label="정상 금액"
        :min-width="columnWidth.price+'px'"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.parent_membership">
            {{ numberWithCommas(scope.row.parent_membership.price) }}
          </template>
        </template>
      </el-table-column>

      <el-table-column
        label="결제 금액"
        :min-width="columnWidth.total+'px'"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.payment">
            {{ numberWithCommas(scope.row.payment.card + scope.row.payment.cash) }}
          </template>
        </template>
      </el-table-column>

      <el-table-column
        label="카드"
        :min-width="columnWidth.card+'px'"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.payment">
            {{ numberWithCommas(scope.row.payment.card) }}
          </template>
        </template>
      </el-table-column>

      <el-table-column
        label="현금"
        :min-width="columnWidth.cash+'px'"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.payment">
            {{ numberWithCommas(scope.row.payment.cash) }}
          </template>
        </template>
      </el-table-column>

      <el-table-column
        label="미수금"
        :min-width="columnWidth.remainder+'px'"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.payment">
            {{ numberWithCommas(scope.row.payment.remainder) }}
          </template>
        </template>
      </el-table-column>

      <el-table-column
        label="결제일"
        :min-width="columnWidth.date"
      >
        <template
          v-if="scope.row.payment"
          slot-scope="scope"
        >
          {{ scope.row.payment.paid_at ? format(scope.row.payment.paid_at, 'YY.MM.DD') : '-' }}
        </template>
      </el-table-column>

      <el-table-column
        label=""
        :min-width="columnWidth.empty+'px'"
        fixed="right"
        class-name="more-action__column"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.type === 'membership'">
            <more-action-dropdown
              :payload-data="scope.row"
              :dropdown-items="membershipDropdownItems"
              @command="handleMembershipRowAction"
            />
          </template>
          <template v-else>
            <more-action-dropdown
              :payload-data="scope.row"
              :dropdown-items="holdingDropdownItems"
              @command="handleHoldingRowAction"
            />
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div class="member-detail-table-control">
      <el-button
        class="calendar icon-word-btn ic-plus float-md-left float-right"
        @click="openMembershipDialogToAdd"
      >
        회원권 추가
      </el-button>
    </div>

    <booking-exist-warning-dialog
      title="홀딩 바로 취소가 불가합니다."
      :message="bookingExistMessage.message"
      :dialog-visible="bookingExistDialogVisible"
      :bookings="bookings"
      :cancel-button-text="`모든 ${bookingSystem} 먼저 취소하고 홀딩 취소`"
      confirm-button-text="확인"
      @confirm="onCancelValidateDialog('bookingExist')"
      @cancel="onConfirmValidateDialog('bookingExist')"
    />
  </div>
</template>

<script>
import dateFns, { format } from 'date-fns';
import { computedGetters } from '@/utils/vuex-helper';
import { numberWithCommas } from '@/utils/etc';
import MembershipFormDialog from './MembershipFormDialog';
import HoldingFormDialog from './HoldingFormDialog';
import MoreActionDropdown from '@/components/MoreActionDropdown';
import BookingExistWarningDialog from '@/components/BookingExistWarningDialog';
import dialogValidateFormMixin from '@/mixins/dialogValidateFormMixin.js';
import AlertDialog from '@/components/AlertDialog';
import { fiflboxApi } from '@/utils/api';
import {
  formResponseErrorHandler,
  HOLDING_DELETE_FAIL_MESSAGES
} from '@/fail-message-handler';

const membershipDropdownItems = [
  {
    label: '홀딩',
    action: 'holding'
  },
  {
    label: '수정',
    action: 'modify'
  },
  {
    label: '삭제',
    action: 'delete'
  }
];

const holdingDropdownItems = [
  {
    label: '수정',
    action: 'modify'
  },
  {
    label: '취소',
    action: 'delete'
  }
];

export default {
  name: 'MemberDetailMembershipTable',
  components: {
    AlertDialog,
    BookingExistWarningDialog,
    MoreActionDropdown,
    HoldingFormDialog,
    MembershipFormDialog
  },
  mixins: [dialogValidateFormMixin],
  props: ['enrollmentId'],
  data() {
    return {
      loading: false,
      membershipDropdownItems,
      holdingDropdownItems,
      membershipTableData: [],
      childMemberships: [],
      holdingChildMembershipId: null,
      membershipDates: [],
      bookings: [],
      columnWidth: {
        membership: 130,
        start: 60,
        end: 60,
        balance: 100,
        consumed: 80,
        price: 80,
        total: 80,
        card: 80,
        cash: 80,
        remainder: 80,
        date: 80,
        empty: 50
      },
      dialog: {
        membership: {
          isVisible: false,
          data: null
        },
        holding: {
          isVisible: false,
          data: null
        }
      },
      bookingExistMessage: {
        message: ''
      },
      bookingExistDialogVisible: false,
      holdingId: null
    };
  },
  async created() {
    this.syncMembershipTableData();
  },
  computed: {
    ...computedGetters(['membershipSystem']),
    isBookingSystem() {
      return this.$store.getters.getIsBookingSystem;
    },
    bookingSystem() {
      return this.isBookingSystem ? '예약' : '수강';
    }
  },
  methods: {
    format,
    tableSpanRule({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'type') {
        return [0, 0];
      }

      if (columnIndex === 1) {
        return [1, 2];
      }

      if (columnIndex === 2) {
        return [0, 0];
      }
    },
    tableHoldingRowClass({ row, rowIndex }) {
      if (row.type === 'holding') {
        return 'fifl-table-holding-row';
      }

      return '';
    },
    openMembershipDialogToAdd() {
      this.$refs['membershipFormDialog'].openDialogToAdd();
    },
    openMembershipDialogToModify(data) {
      this.$refs['membershipFormDialog'].openDialogToModify(data);
    },
    openHoldingDialogToAdd(childMembership) {
      this.$refs['holdingFormDialog'].openDialogToAdd(childMembership);
    },
    openHoldingDialogToModify(holding, childMembership) {
      this.$refs['holdingFormDialog'].openDialogToModify(
        holding,
        childMembership
      );
    },
    async handleMembershipRowAction({ action, data }) {
      if (action === 'holding') {
        return this.openHoldingDialogToAdd(data);
      }

      if (action === 'modify') {
        return this.openMembershipDialogToModify(data.id);
      }

      if (action === 'delete') {
        return this.deleteMembership(data);
      }
    },

    async handleHoldingRowAction({ action, data }) {
      let holdingChildMembership = this.childMemberships.find(
        childMembership => childMembership.id === data.child_membership
      );

      if (action === 'delete') {
        await this.handleClickDeleteHolding(data, holdingChildMembership);
      } else if (action === 'modify') {
        this.openHoldingDialogToModify(data, holdingChildMembership);
      }
    },

    async deleteMembership(data) {
      if (this.childMemberships.length === 1) {
        await this.$alert(
          "적어도 하나 이상의 회원권이 등록되어 있어야합니다. 회원권 변경은 '수정'을 눌러주세요.",
          '회원권 삭제 불가'
        );

        return;
      }

      try {
        await this.$confirm(
          `본 회원권으로 ${
            this.isBookingSystem ? '예약/수강 내역' : '수강한 내역'
          }은 일괄 삭제되며,` +
            '삭제된 회원권은 복구가 불가합니다. 정말로 삭제하시겠습니까?',
          '회원권 삭제'
        );
      } catch (err) {
        return;
      }

      await fiflboxApi.v2.deleteChildMemberships(data.id);

      await this.syncMembershipTableData();

      if (this.childMemberships.length == 1) {
        const id = this.childMemberships[0].payment.id;
        const payload = {
          classification: 1
        };
        await fiflboxApi.v2.putMembershipPayments(id, payload);
      }
    },
    async syncBookings(dt, childMembershipId) {
      let { data: bookings } = await fiflboxApi.v1.getBookings({
        child_membership: childMembershipId,
        status: ['BOOKED', 'PASS'],
        dt_after: dt
      });

      this.bookings = bookings.sort((a, b) => dateFns.compareAsc(a.dt, b.dt));
    },

    async validateBookingExist(childMembership, end) {
      await this.syncBookings(end, childMembership.id);
      const startDate = dateFns.format(childMembership.start, 'YYYY년 M월 D일'),
        endDate = dateFns.format(childMembership.end, 'YYYY년 M월 D일');

      const message =
        `홀딩 취소 시 업데이트될 회원권 기간인 <strong>${startDate} - ` +
        `${endDate}</strong>에 포함되지 않은 ${
          this.bookingSystem
        } 내역이 존재합니다. 아래의 모든 ${
          this.bookingSystem
        } 내역을 먼저 취소해주시길 바랍니다.`;

      return {
        isSuccess: this.bookings.length === 0,
        errorMessage: {
          message
        }
      };
    },

    async handleClickDeleteHolding(holding, childMembership) {
      try {
        await this.$confirm(
          '홀딩을 취소하고 회원권 기간을 복구하시겠습니까?',
          '홀딩 취소',
          {
            confirmButtonText: '확인',
            cancelButtonText: '취소'
          }
        );
      } catch (err) {
        return;
      }

      let holdingDuration =
        dateFns.differenceInDays(holding.end, holding.start) + 1;
      let expectEndDate = dateFns.subDays(childMembership.end, holdingDuration);
      this.holdingId = holding.id;
      const { isSuccess, errorMessage } = await this.validateBookingExist(
        childMembership,
        expectEndDate
      );

      if (!isSuccess) {
        this.bookingExistMessage.message = errorMessage.message;
        return (this.bookingExistDialogVisible = true);
      }

      this.submitForm();
    },

    async submitForm() {
      try {
        await fiflboxApi.v2.deleteMembershipHoldings(this.holdingId);
      } catch (err) {
        let errorCode = err.response.data.error_code;

        if (errorCode === '801') {
          await this.$alert(
            `수정 전 홀딩 기간에 이미 ${
              this.bookingSystem
            } 내역이 존재합니다. ${
              this.bookingSystem
            } 내역을 취소한 후 진행해주시기바랍니다.`,
            '홀딩 수정 불가'
          );
        } else {
          formResponseErrorHandler(HOLDING_DELETE_FAIL_MESSAGES, err);
        }
        return;
      }

      this.$message('홀딩이 취소됐습니다.');
      this.syncMembershipTableData();
    },

    async syncChildMemberships() {
      let { data } = await fiflboxApi.v2.getChildMemberships({
        enrollment: this.enrollmentId
      });
      this.childMemberships = data;
    },
    numberWithCommas,
    async syncMembershipTableData() {
      this.loading = true;
      await this.syncChildMemberships();

      this.membershipTableData = [];

      this.childMemberships.forEach(childMembership => {
        let membership = {
          type: 'membership',
          ...childMembership
        };

        let holdings = childMembership.holdings.map(holding => {
          return {
            type: 'holding',
            child_membership: childMembership.id,
            ...holding
          };
        });

        this.membershipTableData.push(membership);
        this.membershipTableData.push(...holdings);
      });
      this.loading = false;
    },
    onConfirmValidateDialog() {
      this.bookingExistDialogVisible = false;
      this.submitForm();
    },

    onCancelValidateDialog() {
      this.bookingExistDialogVisible = false;
    }
  }
};
</script>

<style lang="scss">
</style>
